<mat-expansion-panel #panel expanded class="bordered" [disabled]="disabled" *ngIf="attachments.length || updateForm.length else panelButton">
   <mat-expansion-panel-header id="attachmentDetails">
      <mat-panel-title>Attachments <lib-info (click)="$event.stopPropagation()"></lib-info> </mat-panel-title>

      <div (click)="$event.stopPropagation()" *ngIf="panel.expanded" class="common-mr1em">
         <ng-container *ngTemplateOutlet="addButton"></ng-container>

         <lib-save-button id="attachmentSave" [state]="attachmentService.savingState" [disabled]="updateForm.invalid" (save)="save.emit(updateForm.value)" [showCancel]="true" (cancel)="updateForm.clear()"></lib-save-button>
      </div>
   </mat-expansion-panel-header>

   <lib-attachment-create *ngIf="updateForm.length" [form]="updateForm" [attachmentTypesEnum]="attachmentTypesEnum"></lib-attachment-create>

   <lib-attachment-select [attachments]="attachments"></lib-attachment-select>
</mat-expansion-panel>

<button id="addAttachmentButton" mat-button color="accent" class="expansion-add-button" *ngIf="!attachments && allowNewAttachments" (click)="uploader.click()">
   <mat-icon id="addIcon">add</mat-icon> ADD ATTACHMENT
</button>

<input id="attachInput" hidden type="file" #uploader (change)="attachFile($event)" [accept]="attachmentService.allowedMimetypes.join(', ')" multiple="true">

<ng-template #addButton>
   <div *ngIf="allowNewAttachments else blockedIcon">
      <div *ngIf="attachmentService.savingState !== 'saving' && !updateForm.length" (click)="uploader.click()">
         <button id="addButton" mat-button color="accent" *ngIf="!breakpoints.xsmall else iconButton">
            <mat-icon id="addButtonIcon">add</mat-icon> ADD ATTACHMENT
         </button>
      </div>
   </div>

   <ng-template #iconButton>
      <button id="iconButton" mat-icon-button color="accent">
         <mat-icon id="iconButtonIcon">add</mat-icon>
      </button>
   </ng-template>
</ng-template>

<ng-template #panelButton>
   <mat-panel-title class="attachment-detail-panel">
      <button id="pannelButton" mat-button color="accent" class="expansion-add-button" (click)="uploader.click()">
         <mat-icon id="panelButtonIcon">add</mat-icon> ADD ATTACHMENT
      </button>
      
      <lib-info 
         class="menu-info" 
         (click)="$event.stopPropagation()">
      </lib-info>
   </mat-panel-title>
</ng-template>

<ng-template #blockedIcon>
   <mat-icon id="warningIcon" color="alert" [matTooltip]="'This type of update is blocked right now.'">warning</mat-icon>
</ng-template>
